export type CreateEnvironmentCopyRequestRequest = {
  envrnmntIdFrom: string;
  envrnmntIdTo: string;
};
